import {
    getDistributorList,   
    getFinalUserList,
    getCallLog,
    getDistributorDetail,
    EmailLogList,
    EmailLogListExport,
    CallLogListExport,
} from '@/api/bd'
import {getToken, removeToken, setToken} from '@/utils/auth'
import {resetRouter} from '@/router'



// 用户记录
const state = {
    distributorListSet: [],
    finalUserListSet:[],
    callLogList:[],
    emailLogList:[],
};

const mutations = {    
    distributorListSet: (state, list) => {
        state.distributorListSet = list;
    },

    finalUserListSet: (state, list) => {
        state.finalUserListSet = list;
    },

    callLogList: (state, list) => {
        state.callLogList = list;
    },
    emailLogList: (state, list) => {
        state.emailLogList = list;
    },
   
}

const actions = {

    async distributorListSet({commit, state},{distributorKey='',finalUserKey=''}) {
        return getDistributorList({userId: getToken(),distributorKey,finalUserKey}).then(response => {
            // console.log('asfasdfsafdasddsasdfsadfsdf',response.data)
            commit('distributorListSet', response.data);
        });
    },

    async finalUserListSet({commit, state},{distributorCode='',finalUserKey=''}) {
        return getFinalUserList({userId: getToken(),distributorCode,finalUserKey}).then(response => {
            // console.log('asfasdfsafdasddsasdfsadfsdf',response.data)
            commit('finalUserListSet', response.data);
        });
    },

    async callLogList({commit, state},{sDate='',eDate='',key='',range='0'}) {
        return getCallLog({userId: getToken(),sDate,eDate,key,range}).then(response => {
            // console.log('asfasdfsafdasddsasdfsadfsdf',response.data)
            commit('callLogList', response.data);
        });
    },

    async emailLogList({commit, state},{emailId='',sDate='',eDate='',key=''}) {
        return EmailLogList({userId: getToken(),sDate,eDate,key}).then(response => {
            // console.log('asfasdfsafdasddsasdfsadfsdf',response.data)
            commit('emailLogList', response.data);
        });
    },

    async EmailLogListExport({commit}, {emailId='',sDate='',eDate='',key=''}) {
        return EmailLogListExport({userId: getToken(),sDate,eDate,key});
    },

    async CallLogListExport({commit}, {emailId='',sDate='',eDate='',key='',range='0'}) {
        return CallLogListExport({userId: getToken(),sDate,eDate,key,range});
    },

}

export default {
    namespaced: true,
    state,
    mutations,
    actions
}
